import { PhoneDto } from '../interfaces/dtos/ContactUsDto';
import { Phone } from '../interfaces/Phone';
import transformPhone from './transformPhone';

export default function transformPhones(dtos: PhoneDto[]): Phone[] {
  const phones: Phone[] = [];
  dtos?.forEach((d) => {
    const p = transformPhone(d);
    if (p !== undefined) phones.push(p);
  });

  return phones.length > 0 ? phones : undefined;
}
